import React from "react";

import { AddIcon } from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import Dialog, { DialogContent, DialogTitle } from "components/Dialog";
import Text from "components/Text";

import AddDealForm from "entities/Deal/components/AddForm";

export interface IAddDealDialog {
  open: boolean;
  handleClose: () => void;
  onCreated?: () => void;
}
const AddDealDialog: React.FC<IAddDealDialog> = ({
  open,
  handleClose,
  onCreated,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      dialogDataTestid="create-deal-dialog"
    >
      <DialogTitle
        sx={{
          margin: theme.spacing(2, 2, 0, 2),
          padding: 2,
          borderRadius: "8px",
          backgroundColor: colors.blue20,
        }}
        flexDirection="row"
        display="flex"
        alignItems="center"
      >
        <AddIcon
          style={{
            height: "40px",
            width: "40px",
          }}
        />
        <Text variant="h1">Create New Deal</Text>
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: "unset" }}>
        <AddDealForm onCreated={onCreated} handleCancel={handleClose} />
      </DialogContent>
    </Dialog>
  );
};

export default AddDealDialog;
